import { DomEventHost, type Unsubscribe } from '@amazon/vinyl-util'
import { isHidden } from '@amazon/vinyl-tsx'

export const windowEvents = new DomEventHost<WindowEventMap>(window)
export const documentEvents = new DomEventHost<DocumentEventMap>(document)

/**
 * Fires `close` when Escape is pressed. Skips events already handled upstream —
 * an open modal/overlay owns Escape at the capture phase and preventDefaults it
 * (see `Modal`) — so a settings page never double-navigates. Returns the
 * Unsubscribe to drop into a disposer.
 */
export function closeOnEscape(close: () => void): Unsubscribe {
    return documentEvents.on('keydown', (event) => {
        if (event.key !== 'Escape' || event.defaultPrevented) return
        event.preventDefault()
        close()
    })
}

export const tabbableQuery = `
  a[href]:not([tabindex="-1"]),
  button:not([disabled]):not([tabindex="-1"]),
  input:not([disabled]):not([tabindex="-1"]),
  textarea:not([disabled]):not([tabindex="-1"]),
  select:not([disabled]):not([tabindex="-1"]),
  details:not([tabindex="-1"]),
  [tabindex]:not([tabindex="-1"]),
  [contenteditable="true"]
`

/**
 * Returns a list of the current visible focusables.
 */
export function getFocusables(): readonly HTMLElement[] {
    return Array.from(document.querySelectorAll<HTMLElement>(tabbableQuery)).filter(
        (e) => !isHidden(e)
    )
}
